/* src/app/modules_v2/income/financial-income/components/financial-income-form/financial-income-form.component.css */
.fif-form {
  padding-bottom: 2rem;
}
.tf-card mat-card-content {
  padding: 1rem 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1f2937;
  margin: 0;
}
.ef-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ef-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ef-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ef-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ef-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-body {
  padding: 14px 20px;
  flex: 1;
}
.ef-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}
.pf-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.pf-btn-cancel {
  border-radius: 8px !important;
  white-space: nowrap;
}
.pf-side-by-side {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
  margin-bottom: 1rem;
}
.pf-side-by-side > .tf-card {
  height: 100%;
}
.pf-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
}
.pf-grid-2 > * {
  min-width: 0;
}
.fif-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: -4px 0 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid var(--cf-border, #e5e7eb);
  color: var(--cf-text-muted, #6b7280);
  font-size: 12.5px;
  line-height: 1.4;
}
.fif-hint mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.fif-error {
  margin: -14px 0 12px 14px;
  font-size: 12px;
  color: var(--cf-error, #dc2626);
}
.fif-retention {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 20px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid var(--cf-border, #e5e7eb);
}
.fif-retention__label {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.fif-retention__label span {
  font-size: 13px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.fif-retention__label small {
  font-size: 12px;
  color: var(--cf-text-muted, #6b7280);
}
.fif-retention__value {
  font-size: 15px;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  white-space: nowrap;
}
@media (max-width: 992px) {
  .pf-side-by-side {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .ef-header {
    padding: 10px 14px;
    gap: 10px;
  }
  .ef-body {
    padding: 10px 12px;
  }
  .pf-grid-2 {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .pf-header-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
/*# sourceMappingURL=financial-income-form.component.css.map */
